/* eslint-disable */
import Bus from 'lib/bus';
import Flag from 'lib/flag';
import {device_supports_touch, set_classes} from 'lib/utilities'

export default function DetectTouchDevice() {
    const bus = new Bus();
    const touchLock = Flag();
    let isTouchSupported = device_supports_touch();
    let isUsingTouch = false;

    constructor();

    function constructor() {
        add_events();
        update_classes();
    }

    function add_events() {
        window.addEventListener('touchstart', on_touch);
        window.addEventListener('touchend', on_touch);
        window.addEventListener('touchmove', on_touch);
        window.addEventListener('mousemove', on_mouse);
    }

    function remove_events() {
        window.removeEventListener('touchstart', on_touch);
        window.removeEventListener('touchend', on_touch);
        window.removeEventListener('touchmove', on_touch);
        window.removeEventListener('mousemove', on_mouse);
    }

    function on_touch() {
        // Due to touch devices also sending through mouse events after the touch events, we need to set a flag
        // to ignore mouse events for a small time period after the touch events. This allows us to properly track
        // whether the user is using the touch screen or the mouse, even when both are active or switching between.
        if (touchLock.isFalse()) {
            touchLock.setTrueFor(250);
        }

        if (! isUsingTouch) {
            isUsingTouch = true;

            bus.emit('is-using-touch');
            bus.emit('change', isUsingTouch);

            update_classes();
        }
    }

    function on_mouse() {
        // See comment in on_touch() function - this makes sure that the pseudo-mouse events emitted by touch devices
        // are ignored.
        if (touchLock.isTrue()) {
            return;
        }

        if (isUsingTouch) {
            isUsingTouch = false;

            bus.emit('is-using-mouse');
            bus.emit('change', isUsingTouch);

            update_classes();
        }
    }

    function update_classes() {
        set_classes(document.documentElement, {
            'is-using-touch': isUsingTouch,
            'is-using-mouse': ! isUsingTouch,
            'device-supports-touch': isTouchSupported
        });
    }

    function destroy() {
        remove_events();
        bus.destroy();
    }

    return {
        isSupported: () => isTouchSupported,
        isUsingTouch: () => isUsingTouch,
        isUsingMouse: () => ! isUsingTouch,
        on: bus.on,
        off: bus.off,
        destroy
    }
}
